import ky from 'ky-universal';

import extendOrInitSession from './extendOrInitSession';
import getGeneralFields from './getGeneralFields';

import { TRACKING_EVENT__IMP_PLACEMENT, TRACKING_OPERATION__SYSCTL, TRACKING_API_ENDPOINT } from '../../../constants';

/**
 * @param {object} opMeta
 */
async function sendImpressionPlacementEvent(op_meta={}) {
  await extendOrInitSession();

  /** @see {@link https://docs.google.com/spreadsheets/d/1OMhlNt-5jTx0Z-LNWI3O_3EbijNopKBE_SdsHPU3Jmw/edit#gid=1786059422} */
  const payload = {
    ...getGeneralFields(),
    event: TRACKING_EVENT__IMP_PLACEMENT,
    op: TRACKING_OPERATION__SYSCTL,
    op_meta,
  };

  await ky.post(TRACKING_API_ENDPOINT, { json: payload, throwHttpErrors: false });
}

import schedulePendingTasks from '../schedulePendingTasks';

export default (...args) => schedulePendingTasks(
  () => sendImpressionPlacementEvent(...args)
);
